document.addEventListener("click", function (e) {
  const plus = e.target.closest(".qty-plus");
  const minus = e.target.closest(".qty-minus");

  if (plus) {
    e.preventDefault();

    const input = plus.parentElement.querySelector(".m-card-qty-input");
    let qty = parseInt(input.value, 10) || 1;
    input.value = qty + 1;
  }

  if (minus) {
    e.preventDefault();

    const input = minus.parentElement.querySelector(".m-card-qty-input");
    let qty = parseInt(input.value, 10) || 1;

    if (qty > 1) {
      input.value = qty - 1;
    }
  }
});